export default function (http) {
    return {
        openCard (data){
            return http.json({
                url: '/card/info/openCard',
                data
            });
        },
        getInfo(data){
            return http.json({
                url: `/card/info/getByCode?code=${data.code}`,
                data
            });
        },

        getWithMoney(data){
            return http.json({
                url: `/card/info/getWithMoney?id=${data.id}`,
                data
            });
        },
        queryCardPage (data){
            return http.json({
                url: '/card/info/query',
                data
            });
        },
        queryCardTotalPage (data){
            return http.json({
                url: '/card/info/queryWithTotal',
                data
            });
        },

        handleHk (data){
            return http.json({
                url: '/card/apply/handleHk',
                data
            });
        },

        handleGs (data){
            return http.json({
                url: '/card/apply/handleGS',
                data
            });
        },
        handleHf(data){
            return http.json({
                url: '/card/apply/handleHf',
                data
            });
        },

        handleDj (data){
            return http.json({
                url: '/card/apply/handleDj',
                data
            });
        },

        changeCardSxDate (data){
            return http.json({
                url: '/card/apply/changeCardSxDate',
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/card.js